import { AttachmentButton, ChatContainer, ConversationHeader, MessageInput, MessageList } from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { IconButton, TextField, useMediaQuery, useTheme } from '@material-ui/core';
import { deviceData } from '@zennya/web-component-library/src/components/Device';
import isEmpty from 'lodash.isempty';
import moment from "moment-timezone";
import { medicalChatChannelState } from 'pages/CustomerBooking';
import { bookingState, medicalPinState, storedMedicalPinState } from 'pages/CustomerBooking/RecoilState';
import { createRef, useCallback, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { sendMessageSupportChat } from 'services/chat.services';
import { parseBookingStatus } from 'util/bookingStates';
import { MessageContent } from '../MessageContent';
import { useStyles } from '../styles';
import { PinView } from './PinView';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import useDocumentHeight from 'util/useDocumentHeight';

const MedicalChat = ({ appBar, source, isAnonymous = false, fingerprint, messageList, reloadMessages = () => { } }) => {
  const classes = useStyles()
  const channelState = useRecoilValue(medicalChatChannelState);
  const fileRef = createRef()
  const [messageAttachment, setMessageAttachment] = useState();
  const storedMedicalPin = useRecoilValue(storedMedicalPinState);
  const medicalPin = useRecoilValue(medicalPinState);
  const routeMatch = useRouteMatch()
  const location = useLocation()
  const history = useHistory()
  const booking = useRecoilValue(bookingState)
  const [chatValue, setChatValue] = useState('');
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });


  const handleAttach = useCallback(
    () => {
      if (fileRef.current) {
        fileRef.current.click();
      }
    },
    [fileRef],
  )

  const handleUpload = useCallback(
    (file) => {
      setMessageAttachment(file)
    },
    [],
  );


  const sendSupportMessageCallback = useCallback(
    async (message) => {
      let payload = null
      if (booking?.id) {
        payload = {
          data: {
            [`${source} Booking`]: {
              "Frontend": `${source} Patient Web App - ${process.env.VERSION} ${process.env.COMMIT_HASH}`,
              "Partner": booking?.white_label_partner?.label,
              "Schedule": moment(booking?.date_scheduled).format('LL LTS'),
              "Booking Status": parseBookingStatus(booking)?.value,
              "Service": booking?.type?.label,
              "Screen": `${source} - ${location.pathname.split(routeMatch.url).filter(t => isEmpty()).join(' ')}`,
              "Device": [deviceData?.os, deviceData?.osName, deviceData?.browserName, deviceData?.browserVersion].filter(t => !isEmpty(t)).join(', '),
              "Appointment": { request_id: booking?.id },
            }
          },
          source: `${source} - ${location.pathname.split(routeMatch.url).filter(t => isEmpty()).join(' ')}`,
        }
      }
      const result = await sendMessageSupportChat(fingerprint, message, messageAttachment, true, payload)
      reloadMessages()
      console.log("📢[index.jsx:89]: ", result);
      setMessageAttachment(false)
    },
    [booking, fingerprint, location.pathname, messageAttachment, routeMatch.url, source],
  );
  const theme = useTheme()
  const webkitDocHeight = useDocumentHeight()
  if (isEmpty(storedMedicalPin) || isEmpty(medicalPin)) {
    return <PinView />
  }

  return (
    <>
      <ChatContainer className={isMobile ? '' : classes.chatContainer}>
        <ConversationHeader>
          <ConversationHeader.Content>
            {appBar}
          </ConversationHeader.Content>
        </ConversationHeader>
        <MessageList 
          style={{

            overflowY: 'scroll',
            overflowX: 'hidden',
            height: `calc(${webkitDocHeight}px - 200px)`,

          }} 
          autoScrollToBottom={false}
        >
          {messageList.map((message, index) =>
            <MessageContent message={message} key={index} />
          )}
        </MessageList>

        <div as={MessageInput} style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          borderTop: "1px dashed #d1dbe4",
          marginBottom: "calc(20px + env(keyboard-inset-height))",
        }}>
          <AttachmentButton
            onClick={() => handleAttach()} style={{
              fontSize: "1.2em",
              alignSelf: "flex-start",

            }} >{messageAttachment?.name}</AttachmentButton>
          <div style={{ display: 'flex', flexDirection: 'row', flex: 1, paddingRight: 10 }}>
            <TextField
              autoFocus
              placeholder='Type message here'
              value={chatValue}
              onChange={e => setChatValue(e.target.value)}
              variant="outlined"
              fullWidth
              size="small"
              color="primary"
              multiline
              maxRows={4}
              style={{
                margin: theme.spacing(1),
              }}
              InputProps={{
                style: {
                  padding: theme.spacing(1),
                  fontSize: theme.typography.body2.fontSize,
                }
              }}
              InputLabelProps={{
                style: {
                  display: 'none'
                }
              }}
            />
            <IconButton size="small"
              color='primary'
              onClick={() => {
                sendSupportMessageCallback(chatValue)
              }}
              disabled={isEmpty(chatValue)}
            >
              <FontAwesomeIcon icon={faPaperPlane} />
            </IconButton>
          </div>

        </div>
      </ChatContainer>
      <input
        ref={fileRef}
        type="file"
        multiple={false}
        hidden
        accept={(channelState?.attachment_mime_types ?? []).join(',')}
        onChange={(e) => handleUpload(e.target.files[0])}
      />
    </>
  )
}

export { MedicalChat };
